// Premissas de Faturamento: página executiva (Diretores/CEO), não escopada por departamento.
// Espelha backend/config.py ROLES_PREMISSAS_FATURAMENTO — mantenha os dois em sincronia.
export const ROLES_PREMISSAS_FATURAMENTO = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO"];
